export default "__VITE_ASSET__DIfk7kQd$ay11pPyWXH$1A__"